import React from 'react';
import { IonContent, IonPage, useIonAlert, useIonRouter } from '@ionic/react';
import { RouteComponentProps } from 'react-router';
import { Form, Input, Select, Space } from 'antd';
import { Button } from 'react-bootstrap';
import { axius, env, func, types } from 'utils';
import { IonLoading, Header } from 'components';

import './Auth.scss';

interface Props extends RouteComponentProps, types.StateProps { };
const Login: React.FC<Props> = props => {

    const { _data: { settings } } = props;

    const [form] = Form.useForm();
    const [presentAlert] = useIonAlert();
    const router = useIonRouter();

    const [vv, setValues] = React.useState({ type: 'RIDER', code: '', username: '' });
    const [code, setCode] = React.useState(false);
    const [count, setCount] = React.useState(0);
    const [loading, setLoading] = React.useState('');

    React.useEffect(() => {
        if (env.NODE_ENV === 'local') {
            form.setFieldsValue({
                country: 'GH',
                phoneNumber: '202810969',
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const resendCountdown = () => {
        setCount(0);
        const timer = setInterval(() => {
            setCount(caunt => caunt + 1);
        }, 1 * 1000);
        return () => {
            clearInterval(timer);
        };
    }

    const submit = (v: any) => {
        if (v.code) {
            submitCode(v);
        } else {
            submitLogin(v);
        }
    }

    const submitLogin = (v: any) => {
        setLoading('authenticating...');
        v['username'] = vv.username || `+${settings.countries?.find(loc => loc.code === v.country)?.callingCode}${v.phoneNumber.replace(/^0/, '')}`;
        axius.post('auth', { ...vv, ...v }).then((res: types.AxiusResponse) => {
            if (res.status === 201) {
                setCode(true);
                setValues(sv => ({ ...sv, ...v }));
                resendCountdown();
            } else {
                if (res.status === 412) {
                    presentAlert(res.data.join('<br />'));
                } else {
                    presentAlert(res.message);
                }
            }
            setLoading('');
        });
    }

    const submitCode = (v: any) => {
        setLoading('authenticating...');
        axius.post('auth/token', { ...vv, ...v }).then((res: types.AxiusResponse) => {
            if (res.status === 201) {
                props.dispatch(props.setAuthenticated({ user: res.data, token: res.token, isLoggedIn: true, }));
                router.push('/', 'none', 'replace');
            } else {
                if (res.status === 412) {
                    presentAlert(res.data.join('<br />'));
                } else {
                    presentAlert(res.message);
                }
                setLoading('');
            }
        });
    }

    return (
        <IonPage id="Login">
            <Header {...props} title="" />

            <IonContent fullscreen={false}>
                <IonLoading open={loading ? true : false} message={loading} onCancel={() => setLoading('')} />
                <div className="p-4 flex-middle">
                    <div style={{ width: '100vw' }}>
                        <h2 className="text-center bolds mb-3 mt-4 animate__animated animate__fadeIn">
                            <b>Login to your account</b>
                        </h2>
                        <p className="text-center text-muted small animate__animated animate__fadeIn">
                            Enter your phone number.
                        </p>
                        <div>&nbsp;</div>
                        <div className="container">
                            <Form form={form} layout="vertical" onFinish={submit} autoComplete="off" style={{ width: '100%' }}>
                                {code ? (
                                    <>
                                        <div className="mb-5">One time code has been sent to <span className="primary">{func.format.phoneNumber(vv.username)}</span>.</div>
                                        <Form.Item name="code" rules={[{ required: true, message: 'Code is required' },]}>
                                            <Input type="number" size="large" className="text-center" autoFocus placeholder="• • • • • •" style={{ letterSpacing: 10 }} />
                                        </Form.Item>
                                        <div>&nbsp;</div>

                                        <Button type="submit" variant="secondary btn-block btn-md">
                                            Verify &amp; Continue
                                        </Button>
                                        <div>&nbsp;</div>

                                        <div className="text-center">
                                            Didn't get the code? {count < 60 ? `Resend in ${60 - count} secs` : <b onClick={() => submitLogin({})}>Resend now</b>}.
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="full-input animate__animated animate__fadeIn">
                                            <Form.Item>
                                                <Space.Compact style={{ width: '100%' }}>
                                                    <Form.Item name="country" noStyle initialValue="NG" rules={[{ required: true, message: 'Country is required' }]}>
                                                        <Select style={{ width: '28vw' }} size="large" disabled={settings.countries.length === 1 ? true : false}>
                                                            {settings.countries.map((loc) => (
                                                                <Select.Option key={loc.code} value={loc.code}>
                                                                    <small>
                                                                        <img
                                                                            src={`https://flagcdn.com/16x12/${loc.code.toLowerCase()}.png`}
                                                                            alt={loc.name}
                                                                        /> &nbsp;
                                                                        +{loc.callingCode}
                                                                    </small>
                                                                </Select.Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                    <Form.Item name="phoneNumber" noStyle rules={[
                                                        { required: true, message: 'Phone number is required' },
                                                    ]}>
                                                        <Input style={{ width: 'calc(100% - 28vw)' }} autoFocus type="number" size="large" placeholder="07000000000" />
                                                    </Form.Item>
                                                </Space.Compact>
                                            </Form.Item>
                                        </div>
                                        <p>&nbsp;</p>
                                        <p>&nbsp;</p>
                                        <div className="animate__animated animate__fadeIn">
                                            <Button type="submit" variant="primary btn-block btn-md">
                                                Sign in
                                            </Button>
                                        </div>
                                    </>
                                )}
                            </Form>
                        </div>
                    </div>
                </div>
            </IonContent>
        </IonPage>
    );
}

export default Login;